 var swiper = new Swiper(".myCarousel", {
  spaceBetween: 20,
  slidesPerView: 3,
  observer: true,
  observeParents: true,
  freeMode: false,
  draggable: true,
  clickable: true,
  breakpoints: {
    750: {
   slidesPerView: 4,
  spaceBetween: 20,
      
    },
    999: {
  slidesPerView: 5,
  spaceBetween: 20,
      
    },
  },
    pagination: {
        el: ".swiper-pagination",
       clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

// end

 var swiper2 = new Swiper(".myCarousel_collection", {
  spaceBetween: 5,
  slidesPerView: 2.3,
  observer: true,
  observeParents: true,
  freeMode: false,
  draggable: true,
  clickable: true,
    breakpoints: {
    750: {
   slidesPerView: 4,
  spaceBetween: 15,
      
    },
  },
      navigation: {
        nextEl: ".swiper-button-nextt",
        prevEl: ".swiper-button-prevt",
      },
    });




 var swiper3 = new Swiper(".my__product_slider", {
  spaceBetween: 0,
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  freeMode: false,
  draggable: true,
  clickable: true,
  breakpoints: {
    750: {
   slidesPerView: 1,
  spaceBetween: 0,
      
    },
    999: {
  slidesPerView: 1,
  spaceBetween: 0,
      
    },
  },
    pagination: {
        el: ".swiper-pagination",
       clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-product",
        prevEl: ".swiper-button-prev-product",
      },
    });